import LoginNewVer from "@components/Auth/LoginNewVer";
import {
  getFirstPromoterReferralCodeFromUrl,
  getReferralCodeFromUrl,
  setReferralCode,
} from "@utils/getReferralCode";
import { useEffect } from "react";

export async function getStaticProps() {
  return {
    props: {
      showPrimaryNav: false,
      showHeader: false,
    }, // Used in Layout to determine if nav should be shown
  };
}

const LoginPage = () => {
  useEffect(() => {
    const referralCode =
      getFirstPromoterReferralCodeFromUrl() || getReferralCodeFromUrl();
    if (referralCode) {
      setReferralCode(referralCode);
    }
  }, []);

  return (
    <div className="onboardingContainer text-black w-full h-full">
      <LoginNewVer />
    </div>
  );
};

export default LoginPage;
